import script from "./ShiftStats.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftStats.vue?vue&type=script&setup=true&lang=js"

import "./ShiftStats.vue?vue&type=style&index=0&id=39009962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39009962"]])

export default __exports__